import React, { useState, useEffect } from "react";
import Select from "../../ui/Select/Select";
import { UserSuggestService } from "../../utils/api";
import useDebounce from "../../hooks/useDebounce";
import useGlobals from "../../hooks/useGlobals";

const UserSuggest = props => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const debSearch = useDebounce(search, 300);

  const globals = useGlobals();

  let computedOptions = options;

  if (
    globals.author_filter &&
    !options.find(user => user.value == globals.author_filter.value)
  ) {
    globals.author_filter.label = globals.author_filter.name;
    computedOptions = [globals.author_filter].concat(computedOptions);
  }

  const handleSearchChange = e => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    setLoading(true);

    UserSuggestService({ term: debSearch }).then(data => {
      setOptions(
        data.users.map(u => {
          u.label = u.name;
          return u;
        })
      );
      setLoading(false);
    });
  }, [debSearch]);

  return (
    <Select
      {...props}
      searchable={true}
      ajax={true}
      handleSearchChange={handleSearchChange}
      options={computedOptions}
      loading={loading}
    />
  );
};

export default UserSuggest;
